import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-email-ring',
  templateUrl: 'email-ring.component.html'
})
export class EmailRingComponent {
  constructor() {}
}
